import Vue from "vue";

export default {
    setSelectedBlurringProject: async ({commit}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'get',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/dtp-blurring-report',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {projectId: selectedProject._id},
            };
            return await Vue.prototype.$http(config)
                .then(async (response) => {
                    console.log('Get blurring videos response: ', response)

                    if (response.data.errorMessage) {
                        return Error(response.data.errorMessage)
                    } else if (response.data.type && response.data.type === 'error') {
                        return Error(response.data.message)
                    } else if (response.status === 200) {
                        console.log('Success!!!')
                        commit('setSelectedBlurringProject', response.data)
                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setSelectedBlurringProject', null)
            commit('setSelectedBlurringDevice', null)
        }
    },
    createBlurringTasks: async ({commit}, siteId) => {
        console.log('Create blurring tasks for site:', siteId)

        const payload = {
            lambdaName: "dtp_create_blurring_tasks",
            query: {
                siteId: siteId, saveTasks:true
            }
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Add new rule response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    //commit('setReport', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });


    },
    runBlurringTasks: async ({commit}, taskIds) => {
        const payload = {
            lambdaName: "dtp_push_blurring_tasks",
            query: {
                taskIds: taskIds,
            }
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Add new rule response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    //commit('setReport', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    resetBlurringTasks: async ({commit}, payload) => {
        console.log('Delete blurring tasks for site:', payload)
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/delete-blurring-tasks',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload,
        };
        return await Vue.prototype.$http(config)
            .then(async (response) => {
                console.log('Get blurring videos response: ', response)

                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    console.log('Success!!!')
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    downloadBlurringVideos: async ({commit}, siteId) => {
        console.log('Download blurring videos for site:', siteId)

        const payload = {
            lambdaName: "dtp_get_blurred_video_links",
            query: {
                siteId: siteId,
            }
        }

        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Add new rule response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    //commit('setReport', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });

    },
    downloadManualPedData: async ({commit}, siteId) => {
        console.log('Download manual ped data for site:', siteId)
        const payload = {
            lambdaName: "dtp_get_manual_ped_data",
            query: {
                siteId: siteId,
            }
        }
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/archiver-lambda-wrapper',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Add new rule response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    //commit('setReport', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });

    },
    setSelectedBlurringDevice: async ({commit}, device) => {
        commit('setSelectedBlurringDevice', device)
    },
    setQueryData: async ({commit}, queryData) => {
        commit('setQueryData', queryData)
    }
}
